<div>
  <div
    class="flex-container"
    style="width: 100%; cursor: pointer"
    (click)="toggle()"
  >
    <div style="flex: 1">
      <h4>
        <span style="font-size: 0.8em" [hidden]="!hidden"
          ><app-icon [type]="IconType.ArrowUp"
        /></span>
        <span style="font-size: 0.8em" [hidden]="hidden"
          ><app-icon [type]="IconType.ArrowDown"
        /></span>
        Level 2 / Level 3 Information
      </h4>
    </div>
    <div
      [hidden]="!hidden"
      style="flex: 1; color: #aaaaaa; font-style: italic; font-size: 0.9em"
    >
      Add Level 2 / Level 3 information here, such as tax type and shipping cost
    </div>
  </div>

  <div class="flex-container" style="width: 100%; gap: 20px" [hidden]="hidden">
    <div
      style="
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        align-self: start;
      "
    >
      <div class="column">
        <app-text-input
          [label]="'Product code'"
          [(ngModel)]="L2L3Data.productCode"
          [helpText]="'If not entered, a code will be generated'"
          (onChanged)="handleProductCodeChanged($event)"
        ></app-text-input>
      </div>

      <div class="column">
        <app-text-input
          [label]="'Quantity'"
          [type]="InputTextModes.Numeric"
          [minNumericValue]="1"
          [(ngModel)]="L2L3Data.quantity"
          (onChanged)="handleQuantityChanged($event)"
        ></app-text-input>
      </div>

      <div class="column">
        <app-ddl-input
          [label]="'Unit of Measure'"
          [type]="DDLModes.UnitsOfMeasure"
          [helpText]="'If not selected, item will be selected'"
          [(ngModel)]="L2L3Data.unitOfMeasure"
          (onChanged)="handleUnitOfMeasureChanged($event)"
        ></app-ddl-input>
      </div>
    </div>

    <div
      style="
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        align-self: start;
      "
    >
      <div class="column">
        <app-text-input
          [label]="'Shipping Cost'"
          [validateOn]="'change'"
          [minNumericValue]="0"
          [showDefaultValue]="false"
          [type]="InputTextModes.CurrencyUSD"
          [(ngModel)]="shippingCost"
          (onChanged)="txtShippingCost_keyup()"
        />
      </div>

      <div class="column">
        <app-text-input
          [label]="'Duty Amount'"
          [type]="InputTextModes.Percent"
          [(ngModel)]="L2L3Data.dutyAmount"
          (onChanged)="handleDutyAmountUpdated($event)"
        ></app-text-input>
      </div>
    </div>
  </div>

  <div
    [hidden]="hidden"
    style="display: flex; flex-direction: row; gap: 10px; align-items: center"
  >
    <h3>Tax Information</h3>
    <button (click)="handleAddTaxClicked()" class="iconButton">
      <app-icon [color]="'white'" type="PlusAdd"></app-icon>
    </button>
  </div>
  @for (tax of taxList; track tax; let i = $index) {
    <div class="flex-container" style="width: 100%" [hidden]="hidden">
      <app-ddl-input
        [label]="'Tax type'"
        [type]="DDLModes.TaxTypes"
        [(ngModel)]="tax.type"
        (onChanged)="handleTaxTypeChanged($event, i)"
      ></app-ddl-input>
      <app-text-input
        [label]="'Tax Amount'"
        [validateOn]="'change'"
        [minNumericValue]="0"
        [showDefaultValue]="false"
        [type]="InputTextModes.CurrencyUSD"
        [(ngModel)]="tax.amount"
        (onChanged)="handleTaxAmountChanged($event, i)"
      ></app-text-input>
      <button (click)="handleRemoveTaxClicked($event, i)" class="iconButton">
        <app-icon [color]="'white'" type="Trash"></app-icon>
      </button>
    </div>
  }
</div>
